import { render, staticRenderFns } from "./logs-layout.vue?vue&type=template&id=61986c3d&scoped=true"
import script from "./logs-layout.vue?vue&type=script&lang=js"
export * from "./logs-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61986c3d",
  null
  
)

export default component.exports